







import Vue, { PropType } from 'vue'
import { WidgetSettingsCustom } from '../widgets/base/widget/WidgetInterface'

export default Vue.extend({
  model: {
    prop: 'data',
    event: 'update'
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: {}
    },
    setting: {
      type: Object as PropType<WidgetSettingsCustom>,
      required: true,
      default: {}
    }
  },
  data() {
    return {
      component: null
    }
  },
  computed: {
    customComponent(): (() => Promise<any>) | null {
      return this.componentFactory(this.setting.template!)
    }
  },
  methods: {
    componentFactory(templateName: string) {
      if (!templateName) {
        return null
      }

      return () => import(`./${templateName}.vue`)
    }
  }
})
